import { useMemo } from 'react';

const COULEURS = ['#A8BBD4', '#7E92B4', '#DCE5EF', '#8C9478'];

export const Petales = ({ nombre = 18 }: { nombre?: number }) => {
  const petales = useMemo(
    () =>
      Array.from({ length: nombre }, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 1.6,
        duree: 3.5 + Math.random() * 3,
        taille: 10 + Math.random() * 14,
        couleur: COULEURS[i % COULEURS.length],
        rot: Math.random() * 360,
      })),
    [nombre]
  );
  return (
    <div className="petales-conteneur" aria-hidden="true">
      {petales.map((p, i) => (
        <svg
          key={i}
          className="petale"
          style={{
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duree}s`,
            width: p.taille,
          }}
          viewBox="0 0 20 28"
        >
          <path
            d="M10 0 C 17 8 20 16 10 28 C 0 16 3 8 10 0 Z"
            fill={p.couleur}
            opacity="0.75"
            transform={`rotate(${p.rot} 10 14)`}
          />
        </svg>
      ))}
    </div>
  );
};
